import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import LabelText from '../../../LabelText';
import CheckboxInput from '../Input';
import ShowOption from './ShowOption';
import ModalInput from './Input';

const CBModal = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const containerRef = useRef(null);

	const modalData = useSelector(state => state.cbModalData);
	const modalOtherData = useSelector(state => state.cbModalOtherData);
	const {checkedValues, form_component} = modalData;
	//console.log(`modalData`, modalData);

	const [showOption, setShowOption] = useState('all');
	const [fv, setFv] = useState(null);

	const cbFieldData = useSelector(state => state.cbFieldData);
	const cbFieldOtherData = useSelector(state => state.cbFieldOtherData);

	useEffect(() => {
		const formElement = document.querySelector('.form'); 

		if (modalData.open) {
			formElement.style.zIndex = '102';

			initFv();
		} else {
			formElement.style.zIndex = '';
		}
	}, [modalData.open]);

	useEffect(() => {
		if (form_component) {
			const {fieldname} = form_component;
			if (typeof cbFieldData[fieldname] === 'undefined') {
				cbFieldData[fieldname] = [];
			};

			const payload = {
				...modalData,
				checkedValues: cbFieldData[fieldname]
			};

			dispatch({type: 'SET_CBMODAL_DATA', payload: payload});
		}
	}, [cbFieldData, form_component]);

	const closeModal = () => {
		$("#cb-modal").modal('hide');

		const payload = {
			...modalData,
			open: false
		};

		if (fv) {
			fv.removeField('option[]');
		}

		dispatch({type: 'SET_CBMODAL_DATA', payload: payload});
	}

	const clearSelection = () => {
		const payload = {
			...modalData,
			checkedValues: []
		};

		dispatch({type: 'SET_CBMODAL_DATA', payload: payload});

		const payload2 = {...cbFieldData};
		payload2[form_component.fieldname] = [];
		dispatch({type: 'SET_CBFIELD_DATA', payload: payload2});

		const payload3 = {...cbFieldOtherData};
		payload3[`${form_component.fieldname}_other`] = '';
		dispatch({type: 'SET_CBFIELD_DATA', payload: payload3});

		closeModal();
	}

	const confirmSelection = () => {
		console.log(`confirmSelection fv`, fv);
		if (fv) {
			// const fields = fv.getFields();
			// if (fields['option[]']) {
			//     console.log('Validators for option[]:', fields['option[]'].validators);
			// } else {
			//     console.log('No validators found for option[]');
			// }

			fv.validate().then(function(status) {
				console.log(`validation status`, status);
				if (status === 'Valid') {
					const payload = {...cbFieldData};

					payload[form_component.fieldname] = checkedValues;

					dispatch({type: 'SET_CBFIELD_DATA', payload: payload});

					const payload2 = {...cbFieldOtherData};
					payload2[`${form_component.fieldname}_other`] = modalOtherData;
					dispatch({type: 'SET_CBFIELD_OTHER_DATA', payload: payload2});

					closeModal();
				}
			});
		}
	}

	function initFv() {
		var validators = {
			validators: {}
		};

		if (form_component.required) {
			validators.validators.notEmpty = {
				message: t('此欄為必須填寫')
			};
		}

		if (form_component.limit_option_select) {
			validators.validators.choice = {
				max: form_component.max_options,
				message: t('最多可選擇 {{0}} 個', {0: number_format(form_component.max_options)})
			};
		}
		//console.log(`option[] validators`, validators);

		const form = containerRef.current;
		//console.log(`form`, form);

		const validator = FormValidation.formValidation(
			form,
			{
				fields: {
					"option[]": validators
				},
				plugins: {
					trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap5({
						rowSelector: '.form-group',
						eleInvalidClass: '',
						eleValidClass: ''
					}),
					autoFocus: new FormValidation.plugins.AutoFocus(),
					declarative: new FormValidation.plugins.Declarative({
						html5Input: true
					})
				}
			}
		);
		console.log(`validator`, validator);

		setFv(validator);
	}

	if (modalData.open) {
		return (
			<div id="cb-modal" className="modal fade quest-drop-modal" tabIndex="-1" aria-hidden="true" data-bs-backdrop="false">
				<div className="modal-dialog modal-dialog-scrollable">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">
								<LabelText
									lang={props.lang}
									form_component={form_component}
								/>
							</h5>
							<button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
						</div>
						<div className="modal-body position-relative p-0" ref={containerRef}>
							<div className="position-sticky top-0 start-0 w-100">
								<div className="d-flex justify-content-between align-items-center border-bottom border-2 bg-light py-3 pe-5 ps-8">
									<p className="mb-0 fs-7">
										{t('已選擇')} <span className="selected-count">{checkedValues.length}</span>
										{/* {form_component.limit_option_select && (
											<span className="select-limit">
												<span className="mx-1">/ {form_component.max_options}</span>
											</span>
										)} */}
									</p>
									<ShowOption
										showOption={showOption}
										setShowOption={setShowOption}
									/>
								</div>
							</div>
							<ul className={`list-unstyled label_box select-list px-3 py-3 form-group ${form_component.option_display === '1R1O' ? 'label-full' : 'label-50'}`}>
								{form_component.options.map((option, index) => (
									(showOption === 'all' || (showOption === 'selected' && checkedValues.includes(option.value))) && (
										<ModalInput
											key={`input-${index}`}
											lang={props.lang}
											option={option}
											checkedValues={checkedValues}
											fv={fv}
										/>
									)
								))}
								{form_component.has_other_option && (
									(showOption === 'all' || (showOption === 'selected' && checkedValues.includes('other'))) && (
										<ModalInput
											key="input-other"
											lang={props.lang}
											option={{
												label: form_component.other_option_label,
												value: 'other'
											}}
											checkedValues={checkedValues}
											fv={fv}
										/>
									)
								)}
							</ul>
						</div>
						<div className="modal-footer">
							<div className="text-danger mb-2 fs-7 validation-message me-3"></div>
							<div className="d-flex justify-content-end gap-3">
								<button type="button" className="btn btn-secondary btn-sm" onClick={clearSelection}>{t('清空')}</button>
								<button type="button" className="btn btn-primary btn-sm" onClick={confirmSelection}>{t('確定')}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	} else {
		return <></>;
	}
}

export default CBModal;